import { useState } from "react";
import MenuItem from "./MenuItem.js";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

const NestedItemsCard = ({ nestedItems }) => {

  // console.log(nestedItems)

  const [isExpand, setIsExpand] = useState(true);
  const expandHandler = () => {
    setIsExpand((prevState) => !prevState);
  };

  //Nested Items may be containing another nested items card inside it
  //Above is the case when nestedItems has categories field

  if(nestedItems.hasOwnProperty("categories")){
    return (
      <>
        <div className="bg-cyan-100 rounded-md flex justify-between text-base sm:text-xl font-semibold py-2 cursor-pointer text-slate-800 px-2">
          <div>{nestedItems.title}</div>
        </div>
        
        {nestedItems?.categories?.map((x) => (
          <NestedItemsCard nestedItems={x} key={x.title} />
        ))}
      </>
    );
    
  }

  const items = nestedItems.itemCards;

  return (
    <div className={!isExpand && "shadow-inner"}>
      <div
        className="flex justify-between text-base sm:text-xl font-semibold py-2 cursor-pointer text-slate-800 px-2"
        onClick={expandHandler}
      >
        <div>{nestedItems.title}</div>
        <span>{isExpand ? <BsChevronUp /> : <BsChevronDown />}</span>
      </div>
      {isExpand &&
        items?.map((item) => (
          <MenuItem key={item.card.info.id} item={item.card.info} />
        ))}

        
    </div>
  );
};

export default NestedItemsCard;
